// 注册全局组件
import Vue from 'vue'
import Pager from '~/components/global/Pager'

Vue.component('y-pager', Pager)
